<div class="dashboard-page container-page">
    <div class="title-page d-flex justify-content-between">
        <div class="title">
            Tạo sản phẩm
        </div>
        <BreadcrumbComponent></BreadcrumbComponent>
    </div>
    <div style="background: #f7f8f9;height: 100%">
        <div class="container-fluid">
            <div class="card">
                <div class="card-body">
                    <div class="search-component d-flex flex-wrap">
                        <div class="col-sm-12 d-flex justify-content-between flex-wrap">
                        </div>

                    </div>
                    <div class="list-partners-component">
                        <div class="col-sm-12 d-flex gap-3 flex-wrap align-content-center flex-column align-items-center">
                            <div class="col-sm-6" v-if="mode === 'create'">
                                <SelectNormal
                                    :label="dataProduct.warehouse_id.label"
                                    :id="dataProduct.warehouse_id.id"
                                    :placeholder="dataProduct.warehouse_id.placeholder"
                                    :value-default="dataProduct.warehouse_id.value"
                                    @inputValue="onChange($event, dataProduct.warehouse_id.id)"
                                    :error-text="dataProduct.warehouse_id.error"
                                    :is-error="dataProduct.warehouse_id.isError"
                                    @blur="validateForm($event, dataProduct.warehouse_id.id)"
                                    :required="dataProduct.warehouse_id.required"
                                    :options="dataProduct.warehouse_id.options"
                                ></SelectNormal>
                            </div>
                            <div class="col-sm-6" v-if="mode === 'detail'">
                                <InputTextNormal
                                    :id="dataProduct.warehouse_id.id"
                                    :label="dataProduct.warehouse_id.label"
                                    :disabled="true"
                                    :value-default="usingWarehouse.name"
                                ></InputTextNormal>
                            </div>
                            <div class="col-sm-6">
                                <InputTextNormal
                                    :label="dataProduct.product_name.label"
                                    :id="dataProduct.product_name.id"
                                    :placeholder="dataProduct.product_name.placeholder"
                                    :value-default="dataProduct.product_name.value"
                                    @inputValue="onChange($event, dataProduct.product_name.id)"
                                    :error-text="dataProduct.product_name.error"
                                    :is-error="dataProduct.product_name.isError"
                                    @blur="validateForm($event, dataProduct.product_name.id)"
                                    :required="dataProduct.product_name.required"
                                ></InputTextNormal>
                            </div>
                            <div class="col-sm-6">
                                <InputTextNormal
                                    :label="dataProduct.product_code.label"
                                    :id="dataProduct.product_code.id"
                                    :placeholder="dataProduct.product_code.placeholder"
                                    :value-default="dataProduct.product_code.value"
                                    @inputValue="onChange($event, dataProduct.product_code.id)"
                                    :error-text="dataProduct.product_code.error"
                                    :is-error="dataProduct.product_code.isError"
                                    @blur="validateForm($event, dataProduct.product_code.id)"
                                    :required="dataProduct.product_code.required"
                                ></InputTextNormal>
                            </div>
                            <div class="col-sm-6">
                                <InputTextNormal
                                    :label="dataProduct.product_quantity.label"
                                    :id="dataProduct.product_quantity.id"
                                    :placeholder="dataProduct.product_quantity.placeholder"
                                    :value-default="dataProduct.product_quantity.value"
                                    @inputValue="onChange($event, dataProduct.product_quantity.id)"
                                    :error-text="dataProduct.product_quantity.error"
                                    :is-error="dataProduct.product_quantity.isError"
                                    @blur="validateForm($event, dataProduct.product_quantity.id)"
                                    :required="dataProduct.product_quantity.required"
                                ></InputTextNormal>
                            </div>
                            <div class="col-sm-6">
                                <InputTextNormal
                                    :label="dataProduct.product_price.label"
                                    :id="dataProduct.product_price.id"
                                    :placeholder="dataProduct.product_price.placeholder"
                                    :value-default="dataProduct.product_price.value"
                                    @inputValue="onChange($event, dataProduct.product_price.id)"
                                    :error-text="dataProduct.product_price.error"
                                    :is-error="dataProduct.product_price.isError"
                                    @blur="validateForm($event, dataProduct.product_price.id)"
                                    :required="dataProduct.product_price.required"
                                ></InputTextNormal>
                            </div>
                            <div class="col-sm-6">
                                <InputTextNormal
                                    :label="dataProduct.product_selling_price.label"
                                    :id="dataProduct.product_selling_price.id"
                                    :placeholder="dataProduct.product_selling_price.placeholder"
                                    :value-default="dataProduct.product_selling_price.value"
                                    @inputValue="onChange($event, dataProduct.product_selling_price.id)"
                                    :error-text="dataProduct.product_selling_price.error"
                                    :is-error="dataProduct.product_selling_price.isError"
                                    @blur="validateForm($event, dataProduct.product_selling_price.id)"
                                    :required="dataProduct.product_selling_price.required"
                                ></InputTextNormal>
                            </div>
                            <div class="col-sm-6">
                                <InputTextNormal
                                    :label="dataProduct.product_unit.label"
                                    :id="dataProduct.product_unit.id"
                                    :placeholder="dataProduct.product_unit.placeholder"
                                    :value-default="dataProduct.product_unit.value"
                                    @inputValue="onChange($event, dataProduct.product_unit.id)"
                                    :error-text="dataProduct.product_unit.error"
                                    :is-error="dataProduct.product_unit.isError"
                                    @blur="validateForm($event, dataProduct.product_unit.id)"
                                    :required="dataProduct.product_unit.required"
                                ></InputTextNormal>
                            </div>
                            <div class="col-sm-6">
                                <InputTextNormal
                                    :label="dataProduct.product_tax.label"
                                    :id="dataProduct.product_tax.id"
                                    :placeholder="dataProduct.product_tax.placeholder"
                                    :value-default="dataProduct.product_tax.value"
                                    @inputValue="onChange($event, dataProduct.product_tax.id)"
                                    :error-text="dataProduct.product_tax.error"
                                    :is-error="dataProduct.product_tax.isError"
                                    @blur="validateForm($event, dataProduct.product_tax.id)"
                                    :required="dataProduct.product_tax.required"
                                ></InputTextNormal>
                            </div>
                            <div class="col-sm-6">
                                <InputTextareaNormal
                                    :label="dataProduct.product_description.label"
                                    :id="dataProduct.product_description.id"
                                    :placeholder="dataProduct.product_description.placeholder"
                                    :value-default="dataProduct.product_description.value"
                                    @inputValue="onChange($event, dataProduct.product_description.id)"
                                    :error-text="dataProduct.product_description.error"
                                    :is-error="dataProduct.product_description.isError"
                                    @blur="validateForm($event, dataProduct.product_description.id)"
                                    :required="dataProduct.product_description.required"
                                ></InputTextareaNormal>
                            </div>
                            <div class="col-sm-2 d-flex flex-column justify-content-end">
                                <ButtonSearchComponent :label="labelButtonSetting" @click="createOrUpdateProduct"></ButtonSearchComponent>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>
